import 'react';
import { ChevronDown, ChevronUp } from 'react-feather';
import { useUncontrolled } from '../../../hooks/useUncontrolled.js';
import { AccordionContext } from './useAccordionContext.js';
import { jsx } from 'react/jsx-runtime';

/* eslint-disable @typescript-eslint/no-explicit-any */
function AccordionProvider({
  children,
  multiple,
  value,
  defaultValue,
  onChange,
  transitionDuration = 100,
  disableChevronRotation,
  expandIcon = /*#__PURE__*/jsx(ChevronDown, {}),
  collapseIcon = /*#__PURE__*/jsx(ChevronUp, {}),
  expandIconPosition = 'right',
  variant = 'default'
}) {
  const [_value, handleChange] = useUncontrolled({
    value,
    defaultValue,
    fallbackValue: multiple ? [] : null,
    onChange
  });
  const isItemActive = itemValue => Array.isArray(_value) ? _value.includes(itemValue) : itemValue === _value;
  const handleItemChange = itemValue => {
    const nextValue = Array.isArray(_value) ? _value.includes(itemValue) ? _value.filter(selectedValue => selectedValue !== itemValue) : [..._value, itemValue] : itemValue === _value ? null : itemValue;
    handleChange(nextValue);
  };
  return /*#__PURE__*/jsx(AccordionContext.Provider, {
    value: {
      isItemActive,
      onChange: handleItemChange,
      getControlId: uid => `${uid}-control`,
      getRegionId: uid => `${uid}-panel`,
      transitionDuration,
      disableChevronRotation,
      expandIconPosition,
      expandIcon,
      collapseIcon,
      variant
    },
    children: children
  });
}

export { AccordionProvider };
